import Button from '@ui-kit/components/Button/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { getConfig } from '@/constants/config';
import { useAcknowledgeTermsAndConditionsMutation } from '@/features/products/hooks/useShowTermsAndConditionsUpdate/useAcknowledgeTermsAndConditionsMutation';

const TermsAndConditionsUpdated = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  const { mutate: acknowledgeTermsAndConditions } = useAcknowledgeTermsAndConditionsMutation();

  return (
    <Modal title={t('TermsAndConditionsUpdated.title')}>
      <p>{t('TermsAndConditionsUpdated.info')}</p>
      <ModalActions>
        <Button
          onClick={() => {
            closeModal();
            acknowledgeTermsAndConditions();
          }}
        >
          {t('TermsAndConditionsUpdated.button2')}
        </Button>
        <AnchorButton
          variant="secondary"
          href={getConfig().externalLinks.terms}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            closeModal();
            acknowledgeTermsAndConditions();
          }}
        >
          {t('TermsAndConditionsUpdated.button1')}
        </AnchorButton>
      </ModalActions>
    </Modal>
  );
};

export default TermsAndConditionsUpdated;
